import styled, { css } from 'styled-components';

export const QuoteWrapper = styled.div`
  blockquote {
    quotes: '“' '”';

    &::before {
      content: open-quote;
    }

    &::after {
      content: close-quote;
    }
  }
`;

const largeQuoteDescriptionStyle = css`
  display: block;

  margin-top: 40px;
`;

export const QuoteDescription = styled.div`
  ${largeQuoteDescriptionStyle}
`;
